<script setup>
import ButtonComponent from "./ButtonComponent.vue";

defineProps({
  variables: {
    type: Object,
    required: true,
  },
  condition: {
    type: Object,
    required: true,
  },
  conditionIndex: {
    type: Number,
    required: true,
  },
  paragraphIndex: {
    type: Number,
    required: true,
  },
  context: {
    type: String,
    required: true,
  },
});

const conditionOperators = {
  lt: "<",
  gt: ">",
  lte: "<=",
  gte: ">=",
  eq: "==",
  ne: "!=",
  eval: "eval",
};

const emit = defineEmits(["delete-condition"]);
</script>

<template>
  <div class="row">
    <div class="pad-s">
      <select
        v-if="condition.operator != 'eval'"
        v-model="condition.variable"
        class="ui-select condition-col-1"
      >
        <option value="__show_once__">Show once</option>
        <option
          v-bind:key="index"
          v-for="(vari, index) in variables"
          :value="index"
        >
          {{ index }}
        </option>
      </select>
    </div>
    <div class="pad-s">
      <select
        v-if="condition.operator != 'eval' && condition.variable != '__show_once__'"
        v-model="condition.operator"
        class="ui-select condition-col-2"
      >
        <option
          v-bind:key="index"
          v-for="(op, index) in conditionOperators"
          :value="index"
        >
          {{ op }}
        </option>
      </select>
    </div>
    <div class="condition-col-grow pad-s">
      <input
        v-if="condition.operator != 'eval' && condition.variable != '__show_once__'"
        type="text"
        v-model="condition.value"
        class="condition-col-3"
      />
      <textarea
        v-if="condition.operator == 'eval'"
        class="textarea"
        v-model="condition.value"
      ></textarea>
    </div>
    <div class="pad-s">
      <ButtonComponent
        :label="null"
        :icon="'trash'"
        :color="'red'"
        :size="'large'"
        @click="
          $emit('delete-condition', [conditionIndex, paragraphIndex, context])
        "
      />
    </div>
  </div>
</template>
